export default "__VITE_ASSET__37efebfb__"